import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import { makeObservableIfNeeded } from "flow/koHelpers/makeObservable";
import { MaybeObservable } from "flow/interfaces/MaybeObservable";

export function selectPlaceholder(
    metaPlaceholderObs: MaybeObservable<string>,
    placeholderObs: MaybeObservable<string>
): KnockoutObservable<string> {
    if (metaPlaceholderObs) {
        return ko.isObservable(metaPlaceholderObs)
            ? metaPlaceholderObs.extend({
                  meta: true
              })
            : makeObservableIfNeeded(metaCache.translate(metaPlaceholderObs));
    } else if (placeholderObs) {
        return makeObservableIfNeeded(placeholderObs);
    }

    return undefined;
}

export function selectLabel(
    metaObs: MaybeObservable<string>,
    textObs: MaybeObservable<string>
): KnockoutObservable<string> {
    if (metaObs) {
        return ko.isObservable(metaObs)
            ? metaObs.extend({
                  meta: true
              })
            : makeObservableIfNeeded(metaCache.translate(metaObs));
    } else if (textObs) {
        return makeObservableIfNeeded(textObs);
    }

    return undefined;
}
